import {
  Card,
  CardContent,
  CircularProgress,
  TextField,
  Grid
} from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import React, { useState, useEffect } from 'react';
import 'react-confirm-alert/src/react-confirm-alert.css';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import axios from 'src/utils/axios';
import { getUser } from 'src/utils/Common';


const useStyles = makeStyles(theme => ({
  root: {
    color: 'white'
  },
  buttonSuccess: {
    position: 'relative',
    float: 'right',
    marginBottom: 10,
    marginLeft: 'auto',
    color: 'white',
    backgroundColor: '#1D3343',
    '&:hover': {
      backgroundColor: '#2f5f82'
    }
  },
  content: {
    minHeight: 130,
    minWidth: 530
  },
  wrapper: {
    '& > div:not(:last-child)': {
      marginBottom: 16
    },
    position: 'relative'
  }
}));

function Follow({
  className, ReceiptNo, readonly, tasks
}) {
  const classes = useStyles();
  const { t } = useTranslation('work_order');
  const SessionUser = getUser();
  const [uyari, setUyari] = useState(false);
  const [uyariTip, setUyariTip] = useState('success');
  const [loading, setLoading] = useState(false);
  const [SKU, setSKU] = useState(' ');
  const [ProductYear, setProductYear] = useState(' ');
  const [ProductMonth, setProductMonth] = useState(' ');
  const [SerialNumber, setSerialNumber] = useState(' ');
  const [IssueNote, setIssueNote] = useState(' ');
  const [ReceiptNote, setReceiptNote] = useState(' ');
  const [IssueDate, setIssueDate] = useState(' ');
  const [ReceiptDate, setReceiptDate] = useState(' ');

  useEffect(() => {
    GetLoanProductForSummary();
  }, []);

  const GetLoanProductForSummary = () => {
    axios
      .get(`/GetLoanProductForSummary/${ReceiptNo || 0}`)
      .then(response => {
        if (response.data.length > 0 && response.data != '') {
          setSKU(response.data[0].SKU);
          setProductYear(response.data[0].ProductionYear);
          setProductMonth(response.data[0].ProductionMonth);
          setSerialNumber(response.data[0].SerialNr);
          setIssueNote(response.data[0].IssueNote);
          setReceiptNote(response.data[0].ReceiptNote);
          setIssueDate(response.data[0].IssueDate);
          setReceiptDate(response.data[0].ReceiptDate);
        } 
      })
      .catch(error => {
        setUyariTip('error');
        setUyari(true);
      });
  };

  return (
    <Card className={clsx(classes.root, className)}>
      <CardContent className={classes.content}>
        <div className={classes.wrapper}>
        <Grid item xs={12}>
                <TextField
                  size="small"
                  id="SKU"
                  autoComplete="no"
                  value={SKU ? SKU : ' '}
                  InputProps={{
                    readOnly: true,
                  }}
                  fullWidth
                  label={t('lblSKU')}
                  variant="outlined"
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  size="small"
                  id="ProductYear"
                  autoComplete="no"
                  value={ProductYear ? ProductYear : ' '}
                  InputProps={{
                    readOnly: true,
                  }}
                  fullWidth
                  label={t('lblProductYear')}
                  variant="outlined"
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  size="small"
                  id="ProductMonth"
                  autoComplete="no"
                  value={ProductMonth ? ProductMonth : ' '}
                  InputProps={{
                    readOnly: true,
                  }}
                  fullWidth
                  label={t('lblProductMonth')}
                  variant="outlined"
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  size="small"
                  id="SerialNumber"
                  autoComplete="no"
                  value={SerialNumber ? SerialNumber : ' '}
                  InputProps={{
                    readOnly: true,
                  }}
                  fullWidth
                  label={t('lblSerialNumber')}
                  variant="outlined"
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  size="small"
                  id="IssueNote"
                  autoComplete="no"
                  value={IssueNote ? IssueNote : ' '}
                  InputProps={{
                    readOnly: true,
                  }}
                  fullWidth
                  label={t('lblIssueNote')}
                  variant="outlined"
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  size="small"
                  id="ReceiptNote"
                  autoComplete="no"
                  value={ReceiptNote ? ReceiptNote : ' '}
                  InputProps={{
                    readOnly: true,
                  }}
                  fullWidth
                  label={t('lblReceiptNote')}
                  variant="outlined"
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  size="small"
                  id="IssueDate"
                  autoComplete="no"
                  value={IssueDate ? IssueDate : ' '}
                  InputProps={{
                    readOnly: true,
                  }}
                  fullWidth
                  label={t('lblIssueDate')}
                  variant="outlined"
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  size="small"
                  id="ReceiptDate"
                  autoComplete="no"
                  value={ReceiptDate ? ReceiptDate : ' '}
                  InputProps={{
                    readOnly: true,
                  }}
                  fullWidth
                  label={t('lblReceiptDate')}
                  variant="outlined"
                />
              </Grid>
        </div>
      </CardContent>
    </Card>

  );
}

Follow.propTypes = {
  className: PropTypes.string
};

export default connect((state) => ({ tasks: state.tasks1 }))(Follow);
